import React from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

const Textslider = {
    breakpoints: {
        0: { slidesPerView: 1 },
        600: { slidesPerView: 1 },
        1000: { slidesPerView: 4 }
      }
};

const textItems = [
    'Parcours personnalisé',
    'Coach IA intelligent',
    'Tests rapides & fun',
    'Recommandations adaptées',
    'Découverte de soi',
    'Insights sur ton profil',
    'Objectifs & progression',
    'Communauté inspirante',
];

function Textlist() {
    return (
        <>
            <div className="text_list_section row_am" data-aos="fade-in" data-aos-duration={1500} >
                <div className="container">
                    <span className="title_badge down_fix">Pourquoi Neoori</span>
                </div>
                <div className="slider_block">
                    <Swiper className="mySwiper" id="text_list_flow" {...Textslider} slidesPerView={2.1}>
                        {textItems.map((item, index) => (
                            <SwiperSlide key={index} className="item">
                                <div className="text_block">
                                    <span>{item}</span>
                                    <span className="mark_star">•</span>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </>
    );
}

export default Textlist;
